<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/work-info-work-type/table' }">职业信息工种</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="dataModel"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item prop="name"
                          label="名称">
              <el-input v-model="dataModel.name"
                        clearable
                        placeholder="请输入工种名称"></el-input>
            </el-form-item>

            <el-form-item prop="business_type_id"
                          label="所属行业">
              <remote-select
                class="width-max"
                clearable
                filterable
                id-key="id"
                label-key="name"
                value-key="id"
                placeholder="输入行业名称搜索"
                v-model="dataModel.business_type_id"
                :disabled="!!id"
                :query-request="queryBusinessType"
                :find-request="findBusinessType">
              </remote-select>
            </el-form-item>

            <el-form-item prop="status"
                          label="状态">
              <el-radio-group v-model="dataModel.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-check"
                     native-type="submit">保存
          </el-button>
          <el-button icon="el-icon-back"
                     @click="$router.push({name: '职业信息工种'})">取消
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataModel: {
        name: '',
        business_type_id: '',
        status: 1,
      },
      businessTypeOptions: [],
      btLoading: false,
      formRules: {
        name: [
          { required: true, message: '请输入工种名称', trigger: 'blur' },
          { max: 200, message: '工种名称长度不能超过200个字符', trigger: 'blur' },
        ],
        business_type_id: [
          { required: true, message: '请选择所属行业', trigger: 'change' },
        ],
        status: [
          { required: true, type: 'number', message: '请选择状态', trigger: 'change' },
        ],
      },
    }
  },

  computed: {
    id () {
      return this.$route.params.id
    },
  },

  created () {
    if (this.id) {
      this.loadData()
    }
  },

  methods: {
    loadData () {
      request.page('workInfoWorkTypeGet', this.id).then(({data}) => {
        this.dataModel = {
          name: data.name || '',
          business_type_id: data.business_type_id || '',
          status: data.status !== undefined ? data.status : 1,
        }
        if (data.business_type_id) {
          this.findBusinessType({id: data.business_type_id}).then(res => {
            const item = res.data || res
            if (item && item.id) {
              const exists = this.businessTypeOptions.find(b => b.id === item.id)
              if (!exists) {
                this.businessTypeOptions.unshift(item)
              }
            }
          }).catch(() => {})
        }
      })
    },

    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }

        const api = this.id ? 'workInfoWorkTypeEdit' : 'workInfoWorkTypeCreate'
        const params = this.id ? {id: this.id, ...this.dataModel} : this.dataModel

        request.common(api, params).then(({data}) => {
          this.$message({
            showClose: true,
            message: this.id ? '修改成功' : '添加成功',
            type: 'success',
          })
          this.$router.push({name: '职业信息工种'})
        })
      })
    },

    queryBusinessType (params = {}) {
      const keyword = params.keyword || params.name || ''
      return request.page('workInfoBusinessTypeQuery', {
        name: keyword,
        per_page: 20,
        current_page: 1,
      })
    },

    findBusinessType ({id}) {
      return request.page('workInfoBusinessTypeGet', id)
    },
  }
}
</script>





// WEBPACK FOOTER //
// src/views/work-info-work-type/pages/WorkInfoWorkTypeForm.vue